/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const BinIcon: React.SFC<any> = (props: any) => {
    return (
        <svg width="13" height="18">
          <g fill="none" fillRule="evenodd">
            <path fill={props.color ? props.color : `#CFD8DD`} d="M0 2h13v2H0zM1 5h11v12c0 .5522847-.4477153 1-1 1H2c-.55228475 0-1-.4477153-1-1V5zm2 2v8h1V7H3zm2 0v8h1V7H5zm2 0v8h1V7H7zm2 0v8h1V7H9z"/>
            <path stroke={props.color ? props.color : `#CFD8DD`} d="M4.5 2.5h4V1c0-.27614238-.22385763-.5-.5-.5H5c-.27614237 0-.5.22385762-.5.5v1.5z"/>
          </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Bin/Bin.tsx